import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { InternalOrganizationUserType } from '@/bundle/_MasterAdmin/types/types';

export type EditInternalOrganizationUserMobilePhonePayloadType = {
  mobile_phone: string;
};

export const editInternalOrganizationUserMobilePhoneApi = async (
  userId: string,
  data: EditInternalOrganizationUserMobilePhonePayloadType
): Promise<ApiResponseType<InternalOrganizationUserType>> => {
  const uri = `/organization/internal/users/${userId}/mobile-phone/`;

  return authApiService.PATCH(uri, data);
};
